export function getOS() {
	const userAgent = navigator.userAgent.toLowerCase();
	if (userAgent.includes('windows')) return 'Windows';
	if (userAgent.includes('mac os')) return 'macOS';
	if (userAgent.includes('linux')) return 'Linux';
	if (userAgent.includes('android')) return 'Android';
	if (userAgent.includes('iphone') || userAgent.includes('ipad')) return 'iOS';
	return 'Desconhecido';
}

export function formatPrice(price: number | string) {
	if (typeof price === 'string') {
		price = parseFloat(price.replace(',', '.'));
	}
	return price.toLocaleString('pt-BR', {
		style: 'currency',
		currency: 'BRL',
	});
}

export function add9Digit(number: string): string {
	const clear = number.replace(/\D/g, '');

	return clear.replace(/^(\d{2})([6-9]\d{3})(\d{4})$/, '$1' + '9' + '$2$3');
}

export function isURL(text: string) {
	const regex =
		/^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/i;
	return regex.test(text);
}
